import { VorlageStationSheet } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateVorlageStation/components/VorlageStationSheet';
import { useForm } from '@/domain/mitarbeiter/features/rotationsplan/features/UpdateVorlageStation/useForm';
import {
  type RotationsplanVorlageDetails,
  type VorlageStationDetails,
  useRotationsplanVorlageById,
} from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlageById/useRotationsplanVorlageById';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

const VORLAGEN_PATH = '/mitarbeiter/rotationsplaene/vorlagen';

export function UpdateVorlageStation() {
  const { vorlageId, abschnittId, stationId } = useParams();
  const { vorlage } = useRotationsplanVorlageById(vorlageId ?? '');
  const navigate = useNavigate();

  const abschnitt = vorlage?.abschnitte.find(({ id }) => id === abschnittId);
  const station = abschnitt?.stationen.find(({ id }) => id === stationId);

  if (!vorlage || !abschnitt || !station) {
    return (
      <Navigate
        to={vorlage ? `${VORLAGEN_PATH}/${vorlage.id}` : VORLAGEN_PATH}
        replace
      />
    );
  }

  return (
    <UpdateVorlageStationSheet
      // neu aufbauen, wenn eine andere Station geöffnet wird
      key={station.id}
      vorlage={vorlage}
      vorlageAbschnittId={abschnitt.id}
      station={station}
      close={() =>
        navigate(`${VORLAGEN_PATH}/${vorlage.id}`, { replace: true })
      }
    />
  );
}

// eigene Komponente, damit useForm nur mit geladener Station aufgerufen wird
function UpdateVorlageStationSheet({
  vorlage,
  vorlageAbschnittId,
  station,
  close,
}: {
  vorlage: RotationsplanVorlageDetails;
  vorlageAbschnittId: string;
  station: VorlageStationDetails;
  close: () => void;
}) {
  const { t } = useTranslation();
  const form = useForm({
    vorlage,
    vorlageAbschnittId,
    station,
  });

  return (
    <VorlageStationSheet
      titel={t('domain.mitarbeiter.rotationsplan.vorlagen.updateStation.titel')}
      vorlage={vorlage}
      form={form}
      close={close}
    />
  );
}
